module.exports = __webpack_public_path__ + "img/mouth-04.98390864.svg";